import slice from 'ramda/src/slice'

export default (text, value, shortening) => {
	if (text.length > value) {
		const newTitle = `${slice(0, shortening || value, text)}...`
		return newTitle
	}
	return text
}
